// extracted by mini-css-extract-plugin
export default {"accordionItem":"MobileAccordionMenuItem-accordionItem--7ea45","accordionItem__active":"MobileAccordionMenuItem-accordionItem__active--67dce"};